import { useState, useEffect } from 'react';

const DEFAULT_OPTIONS = {
  config: { attributes: true, childList: true, subtree: true }
};

export default (targetEl, callback, options = DEFAULT_OPTIONS) => {
  const [observer, setObserver] = useState(null);

  useEffect(() => {
    if (!options?.isConditional || options?.isConditional?.condition) {
      const obs = new MutationObserver(callback);
      setObserver(obs);
    }
  }, []);

  useEffect(() => {
    if (
      !observer ||
      (options?.isConditional && !options?.isConditional?.condition)
    )
      return;
    const { config } = options;
    observer.observe(targetEl, config);
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [observer, targetEl, options]);
};
